"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * @author Siglud <siglud@gmail.com>
 */
var AzureAppServiceDeployDriver_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureAppServiceDeployDriver = void 0;
const tslib_1 = require("tslib");
const typedi_1 = require("typedi");
const lib_1 = require("@feathersjs/hooks/lib");
const addStartAndEndTelemetry_1 = require("../../middleware/addStartAndEndTelemetry");
const commonConstant_1 = require("../../../constant/commonConstant");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const AzureZipDeployImpl_1 = require("./impl/AzureZipDeployImpl");
const ACTION_NAME = "azureAppService/zipDeploy";
let AzureAppServiceDeployDriver = AzureAppServiceDeployDriver_1 = class AzureAppServiceDeployDriver {
    constructor() {
        this.description = (0, localizeUtils_1.getLocalizedString)("driver.deploy.deployToAzureAppServiceDescription");
    }
    async execute(args, ctx) {
        const impl = new AzureZipDeployImpl_1.AzureZipDeployImpl(args, ctx, AzureAppServiceDeployDriver_1.SERVICE_NAME, "https://aka.ms/teamsfx-actions/azure-app-service-deploy", AzureAppServiceDeployDriver_1.SUMMARY, AzureAppServiceDeployDriver_1.SUMMARY_PREPARE);
        return await impl.run();
    }
};
AzureAppServiceDeployDriver.SERVICE_NAME = "Azure App Service";
AzureAppServiceDeployDriver.SUMMARY = ["driver.deploy.azureAppServiceDeployDetailSummary"];
AzureAppServiceDeployDriver.SUMMARY_PREPARE = ["driver.deploy.notice.deployDryRunComplete"];
tslib_1.__decorate([
    (0, lib_1.hooks)([(0, addStartAndEndTelemetry_1.addStartAndEndTelemetry)(ACTION_NAME, commonConstant_1.TelemetryConstant.DEPLOY_COMPONENT_NAME)]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AzureAppServiceDeployDriver.prototype, "execute", null);
AzureAppServiceDeployDriver = AzureAppServiceDeployDriver_1 = tslib_1.__decorate([
    (0, typedi_1.Service)(ACTION_NAME)
], AzureAppServiceDeployDriver);
exports.AzureAppServiceDeployDriver = AzureAppServiceDeployDriver;
//# sourceMappingURL=azureAppServiceDeployDriver.js.map